import type { SmallImageTextContent } from '@/core/types';

import { SmallImageText } from '@/containers/blocks/image-text';

export default function generate({
  content,
  className,
}: {
  content: SmallImageTextContent;
  className?: string;
}) {
  return (
    <SmallImageText
      title={content.title}
      description={content.description}
      image={content.image}
      buttons={content.buttons}
      className={className}
    />
  );
}
